import { render } from "./Form.vue?vue&type=template&id=a142a384&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=a142a384&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a142a384"

export default script